<template>
	<nav v-if="items.length" class="breadcrumb" aria-label="Breadcrumb">
		<a href="/">Home</a>
		<span aria-hidden="true">/</span>
		<span>{{ currentLabel }}</span>
	</nav>
</template>

<script>
export default {
	name: 'Breadcrumb',
	computed: {
		items() {
			return this.$route && this.$route.path !== '/' ? [this.currentLabel] : [];
		},
		currentLabel() {
			const metaTitle = this.$route && this.$route.meta && this.$route.meta.title;
			if (metaTitle) {
				return metaTitle.split('|')[0].replace(/\s+-\s+.*$/, '').trim();
			}
			return (this.$route && this.$route.name) || 'Page';
		},
	},
};
</script>

<style lang="scss" scoped>
.breadcrumb {
	max-width: 1080px;
	margin: 18px auto 0;
	padding: 0 20px;
	display: flex;
	align-items: center;
	gap: 8px;
	color: #667085;
	font-size: 14px;
	line-height: 1.5;
}

.breadcrumb a {
	color: #167a3e;
	text-decoration: none;
	font-weight: 600;
}

.breadcrumb a:hover {
	text-decoration: underline;
}

@media (max-width: 768px) {
	.breadcrumb {
		margin-top: 12px;
		font-size: 13px;
	}
}
</style>
